import { DashboardEventService } from './../dashboard/dashboard-event.service';
import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-operations',
    templateUrl: './operations.component.html',
    styleUrls: ['./operations.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class OperationsComponent implements OnInit, OnDestroy {
    subscription: Subscription;
    viewMode: string;
    constructor(private dashboardEventService: DashboardEventService) {

    }

    ngOnInit(): void {
        this.subscription = this.dashboardEventService.viewModeSelectionSubject.subscribe({
            next: (mode: string) => {
                this.viewMode = mode;
            }
        });
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}